import { qrModules } from './qr';
import { color } from './tokens';

export interface TotpQrProps {
  /** The otpauth:// URL an authenticator app scans. */
  value: string;
  /** Rendered width and height in px. */
  size?: number;
}

/**
 * QR code of a TOTP enrollment URL, drawn as one SVG path with the four-module
 * quiet zone scanners need. Dark on white whatever the page around it.
 */
export function TotpQr({ value, size = 184 }: TotpQrProps) {
  const grid = qrModules(value);
  const quiet = 4;
  const span = grid.length + quiet * 2;
  let d = '';
  grid.forEach((row, r) =>
    row.forEach((dark, c) => {
      if (dark) d += `M${c + quiet} ${r + quiet}h1v1h-1z`;
    }),
  );
  return (
    <svg
      role="img"
      aria-label="QR code for your authenticator app"
      width={size}
      height={size}
      viewBox={`0 0 ${span} ${span}`}
      shapeRendering="crispEdges"
      style={{ display: 'block', borderRadius: 6 }}
    >
      <rect width={span} height={span} fill={color.surface} />
      <path d={d} fill={color.text} />
    </svg>
  );
}
